import React, { useEffect } from "react";
import { MenuItem, Box, FormControl, InputLabel, Select } from "@mui/material";
import { GB, NL, FR, TH, PL, SY, TR, ES } from "country-flag-icons/react/3x2";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

const languages = [
  {
    code: "nl",
    img: <NL style={{ width: "1.5rem", height: "auto" }} />,
    description: "Nederlands",
    descriptionDutch: "Nederlands",
  },

  {
    code: "en",
    img: <GB style={{ width: "1.5rem", height: "auto" }} />,
    description: "English",
    descriptionDutch: "Engels",
  },
];

const LanguageSelect = (props) => {
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.between("mobile", "ipad"));
  const { t, i18n } = useTranslation();

  function handleChangeLanguage(e) {
    const newLng = languages.find(
      (language) => language?.description === e.target.value
    );
    props.handleSelectLanguage(newLng.descriptionDutch);
  }

  useEffect(() => {
    if (props.languageValue) {
      const newLng = languages.find(
        (language) => language?.description === props.languageValue
      );
    }
  }, []);

  return (
    <FormControl sx={{ width: "100%", background: "white" }}>
      <InputLabel>{t("gewensteTaal")}</InputLabel>
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        label="Output taal"
        value={props.languageValue}
        onChange={(e) => props.handleSelectLanguage(e.target.value)}
        sx={{
          display: 'flex',
          backgroundColor: '#F9FCFE', // Light blue background
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#FCFBFB', // Blue border by default
            border: "1px solid #ECF5FD",
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#DCEDFA', // Red border when focused
            border: "1px solid #ECF5FD",
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#DCEDFA', // Keep blue border on hover
            border: "1px solid #ECF5FD",
          },
          '& .MuiSelect-select': {
            backgroundColor: '#F9FCFE', // Light blue background for selected value
          }
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              backgroundColor: '#F9FCFE', // Light blue background for dropdown menu
              '& .MuiMenuItem-root': {
                backgroundColor: '#F9FCFE',
                '&:hover': {
                  backgroundColor: '#DCEDFA', // Slightly darker blue on hover
                },
                '&.Mui-selected': {
                  backgroundColor: '#DCEDFA',
                  '&:hover': {
                    backgroundColor: '#DCEDFA',
                  }
                }
              }
            }
          }
        }}
        native={mobile ? true : false}
      >
        {mobile
          ? languages.map((language, index) => {
              return (
                <option
                  key={index}
                  value={language?.code || ""}
                  style={{
                    display: "flex",
                    gap: "1rem",
                    height: "2rem",
                    alignItems: "center",
                    background: "#fff",
                    width: "100%",
                  }}
                >
                  <Box sx={{ display: "flex", gap: "1rem" }}>
                    <span>{language?.description || ""}</span>
                  </Box>
                </option>
              );
            })
          : languages.map((language, index) => {
              return (
                <MenuItem
                  key={index}
                  value={language?.code || ""}
                  sx={{
                    display: "flex",
                    gap: "1rem",
                    height: "2rem",
                    alignItems: "center",
                    background: "#F9FCFE",
                    width: "100%",
                  }}
                >
                  <Box sx={{ display: "flex", gap: "1rem" }}>
                    {language?.img}
                    <span style={{ fontSize: "16px", fontWeight: 500, color: "#454545" }}>{language?.description || ""}</span>
                  </Box>
                </MenuItem>
              );
            })}
      </Select>
    </FormControl>
  );
};

export default LanguageSelect;
